export default "__VITE_ASSET__KwcqkIzA__"